import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInkEraser = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: "24px",
	viewBox: "0 -960 960 960",
	width: "24px",
	fill: "#e8eaed",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M690-240h190v80H610l80-80Zm-500 80-85-85q-23-23-23.5-57t22.5-58l440-456q23-24 56.5-24t56.5 23l199 199q23 23 23 57t-23 57L520-160H190Zm296-80 314-322-198-198-442 456 64 64h262Zm-6-240Z" })
});
export default SvgInkEraser;
